import React, { useContext } from "react";
import { Link, Typography } from "@mui/material";
import { LanguageContext } from "./LanguageContext";

const Copyright = (props) => {
    const { translations } = useContext(LanguageContext);
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {translations.copyrightAllRights || "All rights reserved."} ©{" "}
            <Link color="inherit" target="_blank" rel="noopener" href="http://kala.rs/">
                Kala Consulting
            </Link>{" "}
            {new Date().getFullYear()}.
            <br />
            <Link color="inherit" target="_blank" rel="noopener" href="https://peo.ba/">
                PIMS Elektro Oprema d.o.o.
            </Link>{" "}
            {translations.copyrightEdition || "edition"}
        </Typography>
    );
};

export default Copyright;